/**
 * Simplified Testimonials JavaScript
 * Works with both slider and grid layouts without jQuery dependency
 */
document.addEventListener('DOMContentLoaded', function() {
    // Function to identify if we're using slider mode
    function detectTestimonialMode() {
        const sliderContainers = document.querySelectorAll('.testimonials .slider-container');
        return sliderContainers.length > 0;
    }
    
    // Fix slider height when in slider mode
    function fixSliderHeight() {
        if (!detectTestimonialMode()) return;
        
        const sliders = document.querySelectorAll('.testimonials .slider-container');
        
        sliders.forEach(slider => {
            // Get the viewport element
            const viewport = slider.querySelector('.wpmslider-viewport');
            if (!viewport) return;
            
            // Find active slide
            const activeSlide = slider.querySelector('.wpmtst-testimonial[aria-hidden="false"]');
            if (!activeSlide) return;
            
            // Set height based on active slide with a small buffer
            const activeHeight = activeSlide.offsetHeight;
            viewport.style.height = 'auto';
            viewport.style.minHeight = (activeHeight + 20) + 'px';
            
            // Position controls
            const controls = slider.querySelector('.wpmslider-controls');
            if (controls) {
                controls.style.top = '50%';
            }
        });
    }
    
    // Center testimonials and make them responsive
    function adjustTestimonialLayout() {
        const testimonials = document.querySelectorAll('.testimonials .wpmtst-testimonial');
        
        testimonials.forEach(testimonial => {
            // Ensure visibility
            testimonial.style.opacity = '1';
            testimonial.style.visibility = 'visible';
            testimonial.style.display = 'block';
            
            // Add specific styles based on viewport width
            if (window.innerWidth <= 768) {
                testimonial.style.fontSize = '0.9rem';
            } else {
                testimonial.style.fontSize = '1rem';
            }
        });
        
        // Handle column layout for grid view
        const strongContents = document.querySelectorAll('.strong-content:not(.wpmslider-content)');
        strongContents.forEach(content => {
            content.style.columnCount = 'auto';
            content.style.display = 'flex';
            content.style.flexWrap = 'wrap';
        });
        
        // If we're in slider mode, fix the slider
        if (detectTestimonialMode()) {
            fixSliderHeight();
        }
    }
    
    // Run these fixes on page load
    adjustTestimonialLayout();
    
    // And when the window is resized
    window.addEventListener('resize', adjustTestimonialLayout);
    
    // Also rerun after a short delay to catch late-loading elements
    setTimeout(adjustTestimonialLayout, 500);
    
    // Add observer for slider changes if in slider mode
    if (detectTestimonialMode()) {
        const sliderContainers = document.querySelectorAll('.testimonials .slider-container');
        
        const observer = new MutationObserver(function() {
            fixSliderHeight();
        });
        
        sliderContainers.forEach(container => {
            observer.observe(container, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['aria-hidden', 'style', 'class']
            });
        });
    }
    
    // Add button hover animations without jQuery
    const navButtons = document.querySelectorAll('.testimonials .wpmslider-controls-direction a');
    navButtons.forEach(btn => {
        btn.addEventListener('mouseenter', function() {
            this.style.transform = 'scale(1.1)';
            this.style.backgroundColor = 'rgba(255, 255, 255, 0.7)';
        });
        
        btn.addEventListener('mouseleave', function() {
            this.style.transform = 'scale(1)';
            this.style.backgroundColor = 'rgba(255, 255, 255, 0.3)';
        });
    });
});